import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { borderWidths, space } from "et3-ui-library";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import HeaderMenu from "./header-menu";
import KhatabaIcon from "./KhatabaIcon";
import UserName from "./UserName";
import getDashBoardStore from "../../stores/dashboard-store";
import Et3Text from "../../core/et3-text";
import i18n from "../../constants/i18n";
import getCoreUIStore from "../../stores/core/core-ui-store";
import MobileNavToggle from "./MobileNavToggle";

const Header = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const isAlert = getDashBoardStore().getIsAlert.get();
  const isMobileNav = getCoreUIStore().isMobileNav.get();
  const shouldShowSideBar = getCoreUIStore().shouldShowSideBar.get();

  return (
    <AppBar
      component="header"
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: 100,
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: `${borderWidths.thin}px solid`,
        borderColor: "divider"
      }}
    >
      <Toolbar
        disableGutters
        variant={isMobileNav ? "regular" : "dense"}
        sx={{
          height: isMobileNav ? undefined : 120 * unitY,
          minHeight: isMobileNav ? undefined : 0,
          alignItems: "stretch"
        }}
      >
        <Box
          sx={{
            width: shouldShowSideBar ? 300 * unitX : "auto",
            px: shouldShowSideBar ? 0 : 1,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRight: shouldShowSideBar
              ? `${borderWidths.thin}px solid`
              : "none",
            borderColor: "divider"
          }}
        >
          {isMobileNav ? <MobileNavToggle /> : <KhatabaIcon />}
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: "flex",
            alignItems: "stretch",
            gap: isMobileNav ? 1 : 3,
            pl: `${Math.max(0, 40 * unitX - space(2))}px`,
            pr: `${40 * unitX}px`
          }}
        >
          <HeaderMenu />
          <UserName />
        </Box>
      </Toolbar>
      {isAlert ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={1920}
          height={50}
          fDirection={"row"}
          color={colors.all.red}
          style={{}}
          alignItems="center"
          justifyContent="center"
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={24}
            text={i18n.get("ALERT")}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </ET3Div>
      ) : null}
    </AppBar>
  );
});
export default Header;
